import {
  THREAD_KINDS,
  TURN_INTENTS,
  TURN_ROLES,
  type ThreadKind,
} from './shared-responder-v2-core-thread.consts';
import type {
  QuestionSpec,
  ResponderThread,
  ResponderTurn,
  ResponderTurnPrompt,
} from './shared-responder-v2-core-thread.types';

export function selectPendingFollowUp(
  thread: ResponderThread
): ResponderTurn | null {
  if (thread.isFollowUpSkipped === true) {
    return null;
  }

  for (let index = thread.turns.length - 1; index >= 0; index -= 1) {
    const turn = thread.turns[index];

    if (turn?.role === TURN_ROLES.Responder) {
      return null;
    }

    if (turn?.intent === TURN_INTENTS.FollowUpQuestion) {
      return turn;
    }
  }

  return null;
}

export function toFollowUpSpec(
  prompt: ResponderTurnPrompt,
  baseSpec: QuestionSpec
): QuestionSpec {
  return {
    ...baseSpec,
    optionValues: prompt.optionValues,
    optionLabels: prompt.optionLabels,
    minSelections: prompt.minSelections,
    maxSelections: prompt.maxSelections,
    isRequired: prompt.isRequired,
  };
}

/** Only the Task card picks a follow-up's options; every other kind answers it as prose. */
export function resolvePickedFollowUpPrompt(
  kind: ThreadKind,
  turn: ResponderTurn | null
): ResponderTurnPrompt | null {
  if (kind !== THREAD_KINDS.Task) {
    return null;
  }

  const prompt = turn?.prompt ?? null;

  return prompt !== null && prompt.optionValues.length > 0 ? prompt : null;
}
